// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics"; // Có thể bỏ nếu không dùng Analytics
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth"; // Thêm dòng này để import Firebase Authentication
import { getFirestore } from 'firebase/firestore';
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAvOsQGhXx-cox-qCpb4g5hc2iSlc57eT8", // Đây là key của bạn
  authDomain: "project-bee-84b5e.firebaseapp.com",
  projectId: "project-bee-84b5e",
  storageBucket: "project-bee-84b5e.firebasestorage.app",
  messagingSenderId: "457077009812",
  appId: "1:457077009812:web:2c8f115037e3f909343381",
  measurementId: "G-TGW731S9LS", // Có thể bỏ nếu không dùng Analytics
  databaseURL: "https://project-bee-84b5e-default-rtdb.firebaseio.com"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app); // Có thể bỏ nếu không dùng Analytics
const database = getDatabase(app);
const auth = getAuth(app); // Khởi tạo Auth
const firestore = getFirestore(app); // Khởi tạo Firestore nếu cần
export { database, auth, app, firestore }; // Export cả 'app' nếu bạn cần dùng nó ở đâu đó, và 'auth'